import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { fetchLlmUsage } from "@/lib/api";

// Bottom-of-page strip showing today's AI (Claude) call count and the estimated
// Emergent credit consumption. Credits are an ESTIMATE (no official per-call rate).
export const LlmUsageFooter = () => {
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      fetchLlmUsage()
        .then((d) => alive && setUsage(d))
        .catch(() => {});
    load();
    const id = setInterval(load, 3 * 60 * 1000); // refresh every 3 min
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);

  if (!usage) return null;

  const calls = usage.today ?? 0;
  const credits = usage.credits_today ?? 0;
  const perCall = usage.credits_per_call ?? 5;

  return (
    <footer
      data-testid="llm-usage-footer"
      className="w-full mt-auto border-t border-zinc-500/20 bg-muted"
    >
      <div className="mx-auto flex w-full max-w-[1600px] flex-col sm:flex-row sm:items-center justify-between gap-y-3 px-4 py-3 text-[11px] font-mono">
        <div className="flex items-center gap-2">
          <Sparkles className="h-3.5 w-3.5 text-[hsl(var(--primary))]" />
          <span className="uppercase tracking-widest text-zinc-400 font-medium">
            AI Usage · Today
          </span>
        </div>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <span data-testid="llm-usage-calls" className="flex items-center gap-1.5">
            <span className="uppercase tracking-wider text-zinc-500">Calls</span>
            <span className="tabular-nums font-semibold text-zinc-200">{calls}</span>
          </span>
          <span className="h-3 w-px bg-zinc-500/30" aria-hidden />
          <span data-testid="llm-usage-credits" className="flex items-center gap-1.5">
            <span className="uppercase tracking-wider text-zinc-500">Est. Credits</span>
            <span className="tabular-nums font-semibold text-[hsl(var(--primary))]">
              ~{credits}
            </span>
          </span>
          <span className="hidden sm:block h-3 w-px bg-zinc-500/30" aria-hidden />
          <span
            data-testid="llm-usage-note"
            className="text-zinc-500 uppercase tracking-widest text-[9.5px]"
          >
            (≈{perCall} credits/call · resets 00:00 UTC · estimate)
          </span>
        </div>
      </div>
    </footer>
  );
};

export default LlmUsageFooter;
